export default "__VITE_ASSET__5hwwrjLi__"